import * as React from 'react';
import useOnRouteUpdate from 'core/hooks/useOnRouteUpdate';
import useGoogleAnalytics from './useGoogleAnalytics';

export default function useGAPageTracking() {
    const { trackGA4OnPageLoad, trackWithAnyGoogleAnalytics, conversionEvent } =
        useGoogleAnalytics();

    const onRouteUpdate = React.useCallback(
        (newPathName: string) => {
            trackGA4OnPageLoad();

            if (conversionEvent && newPathName === '/booking/finished') {
                trackWithAnyGoogleAnalytics(false, 'event', 'conversion', {
                    send_to: conversionEvent,
                });
            }
        },
        [trackGA4OnPageLoad, trackWithAnyGoogleAnalytics, conversionEvent],
    );

    useOnRouteUpdate(onRouteUpdate);
}
